







































import { Component, Vue, Prop } from 'vue-property-decorator';
import { BIconInfoCircle } from 'bootstrap-vue';
import {MSG_BIP, MSG_SMS, trMsg} from "@/modules/budget/bip/bip-types";

export interface iAgrBtns {
    back: any[],
    forward: any[]
}

@Component({
    name: 'c-budg-agr-modal',
    components: { BIconInfoCircle }
})
export default class CBudgetAgreementModal extends Vue {
    @Prop({
        required: true,
        default: { back: [], forward: [] }
    })
    private agrBtnLst!: iAgrBtns;

    // необязательный текст предупреждения под комментарием 
    @Prop({required: false, default: ''}) private warningTxt!: string;

    // текст ошибки при пустом комментарии на шаге назад; 
    @Prop({required: false, default: ''}) private backCommentRequiredTxt!: string;

    // шаг назад нажат с пустым комментарием - подсветка поля и текст ошибки до ввода комментария
    private commentError = false;

    private MSG_BIP = MSG_BIP;
    private MSG_SMS = MSG_SMS;

    created() {
        this.$watch('agrBtnLst', () => {
            try {
                for (const btn of this.agrBtnLst.back) {
                    if (!btn.name) {
                        btn.name = btn[`name_${this.$i18n.locale}`];
                    }
                }
                for (const btn of this.agrBtnLst.forward) {
                    if (!btn.name) {
                        btn.name = btn[`name_${this.$i18n.locale}`];
                    }
                }
            } catch {}
        }, {deep: true});
        this.$watch('commentTxt', () => {
            if (this.commentError && this.commentTxt.trim()) { this.commentError = false; }
        });
    }

    private showModal = false;

    private commentTxt = '';

    // отправка начата - защита от повторного нажатия, пока модалка ещё не скрыта из DOM
    private sending = false;

    private showEvent() {
        this.sending = false;
        this.commentError = false;
        this.showModal = true;
    }

    private clkBtn(code: number, stepType: number) {
        if (this.sending) { return; }
        if (stepType === 1 && this.backCommentRequiredTxt && !this.commentTxt.trim()) {
            this.commentError = true;
            return;
        }
        this.sending = true;
        const saveObj = { status: code, commentTxt: this.commentTxt, stepType: stepType };
        this.$emit('agrClk', saveObj);
        this.showModal = false;
        this.commentTxt = '';
    }

    /* закрытие модалки без действия */
    private onHidden() {
        if (this.sending) { return; }
        this.$emit('closed');
    }

    // translate messages
    trMsg(field: string) {
        return trMsg(this, field);
    }
}
